<template>
   <svg viewBox="0 0 95 51" fill="none" aria-hidden="true" focusable="false">
      <path d="M84.379 0L55.4167 0V15.5482L84.379 0Z" fill="#012169" />
      <path d="M10.621 51H39.5833V35.4518L10.621 51Z" fill="#012169" />
      <path d="M39.5833 0L10.621 0L39.5833 15.5482V0Z" fill="#012169" />
      <path d="M0 34L0 45.2982L21.0457 34H0Z" fill="#012169" />
      <path d="M0 5.70178L0 17H21.0457L0 5.70178Z" fill="#012169" />
      <path d="M95 17V5.70178L73.9543 17H95Z" fill="#012169" />
      <path d="M55.4167 51H84.379L55.4167 35.4518V51Z" fill="#012169" />
      <path d="M95 45.2982V34H73.9543L95 45.2982Z" fill="#012169" />
      <path
         d="M63.3333 17H56.2527L87.9193 0L84.379 0L55.4167 15.5482V0L52.25 0V17.2482V19.1488V20.4H57L67.621 20.4H95V17H73.9543L95 5.7018V0L63.3333 17Z"
         fill="white"
      />
      <path d="M63.3334 17L95 0L87.9194 0L56.2527 17H63.3334Z" fill="#C8102E" />
      <path d="M31.6667 17H38.7473L7.08067 0L0 0L0 3.8012L24.586 17H31.6667Z" fill="#C8102E" />
      <path d="M63.3334 34H56.2527L87.9194 51H95V47.1988L70.414 34H63.3334Z" fill="#C8102E" />
      <path d="M31.6667 34L24.586 34L0 47.1988L0 51H7.08067L38.7473 34H31.6667Z" fill="#C8102E" />
      <path
         d="M42.75 31.8512V30.6H38H30.9193H27.379L0 30.6L0 34H21.0457L0 45.2982L0 47.1988L24.586 34L31.6667 34H38.7473L7.08067 51H10.621L39.5833 35.4518V51H42.75V33.7518V31.8512Z"
         fill="white"
      />
      <path
         d="M64.0807 30.6H57H52.25V31.8512V33.7518V51H55.4167V35.4518L84.379 51H87.9193L56.2527 34H63.3333H70.414L95 47.1988V45.2982L73.9543 34L95 34V30.6H67.621L64.0807 30.6Z"
         fill="white"
      />
      <path
         d="M30.9193 20.4H38H42.75V19.1488V17.2482V0L39.5833 0V15.5482L10.621 0L7.08067 0L38.7473 17H31.6667H24.586L0 3.8012L0 5.7018L21.0457 17L0 17L0 20.4L27.379 20.4H30.9193Z"
         fill="white"
      />
      <path
         d="M57 20.4H52.25V19.1488V17.2482V0L47.5 0L42.75 0V17.2482V19.1488V20.4H38H30.9193H27.379L0 20.4L0 25.5L0 30.6L27.379 30.6H30.9193H38H42.75V31.8512V33.7518V51H47.5H52.25V33.7518V31.8512V30.6H57H64.0807H67.621L95 30.6V25.5V20.4L67.621 20.4H57Z"
         fill="#C8102E"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
